module.exports = __webpack_public_path__ + "img/orange-right-fullres.7dcb0b02.png";